import { ListConfigs } from "../../../sharedComponent/SearchList/SearchList.types";

export const OUTBOUNDLISTCONFIGS: ListConfigs[] = [
    {
      headerName: 'Customer Name',
      apiFieldName: 'customerName',
      columnWidth: '150',
      type: 'TEXT',
    },
    {
        headerName: 'Make Call',
        apiFieldName: 'image',
        columnWidth: '150',
        type: 'IMAGE',
      }
]

export const mockData=[{
    customerName:"Eliyas",
    image:"Sidebar-Menuphone.svg"
},
{
    customerName:"Eliyas",
    image:"Sidebar-Menuphone.svg"
},{
    customerName:"Eliyas",
    image:"Sidebar-Menuphone.svg"
},{
    customerName:"Eliyas",
    image:"Sidebar-Menuphone.svg"
},{
    customerName:"Eliyas",
    image:"Sidebar-Menuphone.svg"
}]
